// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".diagnosis-namespaceWrapper-b382d{margin-bottom:8px}.diagnosis-proxyTableWrapper-e7913 .icloud-ui-pro-table-toolbar{display:block!important}.diagnosis-proxyTableWrapper-e7913 .icloud-ui-pro-table-toolbar .icloud-ui-pro-table-toolbar-right{display:flex;justify-content:space-between}.diagnosis-proxyTableWrapper-e7913 .icloud-ui-pro-table-toolbar .icloud-ui-pro-table-toolbar-right .icloud-ui-pro-table-filters{margin-left:0}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"namespaceWrapper": "diagnosis-namespaceWrapper-b382d",
	"proxyTableWrapper": "diagnosis-proxyTableWrapper-e7913"
};
export default ___CSS_LOADER_EXPORT___;
